"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema = {
    type: "object",
    properties: {
        dateOfTransfer: {
            type: "number",
            format: "date",
            title: "Date of Transfer",
        },
        hospitalTransferredTo: { type: "string", title: "Hospital Transferred To" },
        reasonForTransfer: { type: "string", title: "Reason for Transfer" },
        caseManagerAtHospital: {
            type: "string",
            title: "Case Manager At Hospital",
        },
        phoneNumberWithCountryCode: {
            type: "object",
            properties: {
                countryCode: {
                    type: "string",
                    oneOf: [
                        {
                            const: "+1",
                            title: "+1 United States",
                        },
                        {
                            const: "+91",
                            title: "+91 India",
                        },
                        {
                            const: "+63",
                            title: "+63 Philippines",
                        },
                    ],
                    title: "Country Code",
                },
                phoneNumber: {
                    type: "integer",
                    title: "Phone Number",
                },
            },
        },
        faxNumberToHospital: {
            type: "string",
            title: "Fax Number To Hospital",
            maxLength: 10,
        },
        nextDoctorVisit: {
            type: "string",
            format: "date",
            title: "Next Doctor Visit",
        },
        notes: { type: "string", title: "Notes", maxLength: 3000 },
        physicianNotified: {
            type: "boolean",
            default: false,
            oneOf: [
                { const: true, title: "Yes" },
                { const: false, title: "No" },
            ],
        },
    },
    required: ["dateOfTransfer", "hospitalTransferredTo", "reasonForTransfer"],
};
exports.default = schema;
